import { css } from '@emotion/css'
import { ToggleButton } from 'components/ToggleButton/ToggleButton'
import { translate } from 'i18n/i18n'
import type { TAppliedIrrigationActivityDisplayOption } from 'stores/smallStore/smallStore'
import { smallStore } from 'stores/smallStore/smallStore'

export const IrrigationActivityToggleButton = () => {
  const appliedIrrigationActivityDisplay = smallStore.useSelector((s) => s.appliedIrrigationActivityDisplay)

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <ToggleButton
        buttonProps={{ size: 'xs', className: css({ fontSize: 13 }) }}
        data={[
          { label: translate.phrases.banyanApp('Volume'), value: 'VOLUME' },
          { label: translate.phrases.banyanApp('Duration'), value: 'DURATION' },
        ]}
        onChange={(newValue: TAppliedIrrigationActivityDisplayOption) =>
          smallStore.setState((s) => ({
            ...s,
            appliedIrrigationActivityDisplay: newValue,
          }))
        }
        value={appliedIrrigationActivityDisplay}
      />
    </div>
  )
}
